import { Component, OnInit, ViewChild, ElementRef, Inject, Renderer2, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

  email = '';
  name = '';
  icon = 'pie-chart';
  isAuthenticated: boolean;
  subscription: Subscription;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.subscription = this.authService.authNavStatus$.subscribe(status => this.isAuthenticated = status);
    this.email = this.authService.email;
    this.name = this.authService.name;
  }


  toggleSidebar(e) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }


  async onLogout(event: any) {
    event.preventDefault();
    await this.authService.signout();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  goToLogin(event: any) {
    event.preventDefault();
    this.router.navigate(['/account/login']);
  }

  goToRegister(event: any) {
    event.preventDefault();
    this.router.navigate(['/account/register']);
  }

}
